import styles from "@/Administration/Components/Roles/RoleManagementComponent.module.scss";

function RolesSearchVisibilityToggle(props: Readonly<{ onClick: () => void }>): JSX.Element {
    return (
        <div
            className={`aside-handle responsive ${styles.rolesMenuHandle}`}
            onClick={props.onClick}
            data-cy="searchRoleMenuToggle"
        >
            <div className="slide-menu-icon blue d">
                <span /><span /><span />
            </div>
        </div>
    );
}

export { RolesSearchVisibilityToggle };
